const AttendeeMissingRequiredInfo = {
  initialize() {
    return $("#missing_required_info").on("click", e => {
      const signInUrl = $(e.target).data("sign-in-url")
      return alertModal(
        {
          title: "Required Information Missing",
          text: "Please sign in to update the required private information.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Ok, sign in",
          customClass: "warning",
          closeOnConfirm: true
        },
        function() {
          window.location.href = signInUrl
        }
      )
    })
  }
}

export default AttendeeMissingRequiredInfo
